import React, { useEffect } from 'react'
import axios from 'axios'
import { useForm } from 'react-hook-form'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import MapIcon from './../../../../../assets/img/map.svg'

import './index.css'


export default function AddressForm() {
    const { register, handleSubmit, watch, setValue } = useForm();
    const zipCode = watch('zipCode');

    useEffect(() => {
        if (zipCode && zipCode.length >= 8)
            getAddressData()
    }, [zipCode]) // eslint-disable-line react-hooks/exhaustive-deps

    async function getAddressData() {
        try {
            let response = await axios.get(`http://viacep.com.br/ws/${zipCode}/json/`)
            renderAddressData(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    const renderAddressData = address => {
        setValue('zipCode', address.cep)
        setValue('address', address.logradouro)
        setValue('neighbourhood', address.bairro)
        setValue('city', address.localidade)
        setValue('uf', address.uf)
        setValue('ibge', address.ibge)
    }

    const save = data => {
        console.log(data)
    }


    return (
        <div className="AddressForm">
            <div className="container-map-icon">
                <img className="img-fluid" src={MapIcon} alt="Endereço" width="200"/>
            </div>
            <Form onSubmit={handleSubmit(save)}>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>CEP</Form.Label>
                            <Form.Control type="text" name="zipCode" ref={register} placeholder="CEP" />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Numero</Form.Label>
                            <Form.Control type="number" name="number" ref={register} placeholder="Número" />
                        </Form.Group>
                    </Col>
                </Row>


                <Form.Group>
                    <Form.Label>Endereço</Form.Label>
                    <Form.Control type="text" name="address" ref={register} placeholder="Endereço" />
                </Form.Group>

                <Row>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Bairro</Form.Label>
                            <Form.Control type="text" name="neighbourhood" ref={register} placeholder="Bairro" />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Cidade</Form.Label>
                            <Form.Control type="text" name="city" ref={register} placeholder="Cidade" />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>UF</Form.Label>
                            <Form.Control type="text" name="uf" ref={register} placeholder="UF" />
                        </Form.Group>
                    </Col>

                    <input type="hidden" name="ibge" ref={register} />
                </Row>

                <Button variant="primary" className="btn-full" type="submit">
                    Salvar
                </Button>
            </Form>
        </div>
    )
}